/**
 * Human-readable message from axios / fetch errors, including RFC 7807 Problem Details.
 */
export function getMessageFromApiError(err: unknown): string {
  const ax = err as {
    response?: { data?: unknown; status?: number };
    message?: string;
  };
  const data = ax?.response?.data;
  if (data && typeof data === 'object' && data !== null) {
    const o = data as Record<string, unknown>;
    if (typeof o.detail === 'string' && o.detail.trim()) return o.detail;
    if (typeof o.title === 'string' && o.title.trim()) return o.title;
    if (typeof o.Message === 'string' && o.Message.trim()) return o.Message;
    if (typeof o.message === 'string' && o.message.trim()) return o.message;
    if (typeof o.ErrorMessage === 'string' && o.ErrorMessage.trim()) return o.ErrorMessage;
  }
  if (typeof ax?.message === 'string' && ax.message.trim()) return ax.message;
  return 'Payment could not be started. Please try again later.';
}
